<template>
  <div class="time-selector-container">
        <div class="cell" :class="{ active: value === 0 }" @click="onChange(0)">今日</div>
    <div class="cell" :class="{ active: value === 1 }" @click="onChange(1)">昨日</div>
    <!-- <div class="cell" :class="{ active: value === 3 }" @click="onChange(3)">3日</div>
    <div class="cell" :class="{ active: value === 7 }" @click="onChange(7)">7日</div> -->
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number
    }
  },
  methods: {
    onChange(num) {
      this.$emit('input', num)
    }
  }
}
</script>

<style lang="less" scoped>
.time-selector-container {
  display: flex;
  justify-content: flex-end;
  .cell {
    width: 82px;
    height: 30px;
    line-height: 30px;
    background: #F5F6FA;
    border-radius: 4px;
    text-align: center;
    color: #333333;
    font-size: 12px;
    cursor: pointer;

    &.active {
      background: #1990ff;
      color: #ffffff;
    }
  }
}
</style>
